import FieldsCollection from "../../fields3/collection/base/fields-collection"
import {EntityType} from "../../gd/const/item"
import {FieldType} from "../../fields3/field-type"
import FieldString from "../../fields3/generic/string/string"
import FieldConfig from "../../fields3/proto/field-config"
import FieldIcon from "../../fields3/generic/icon/icon"
import FieldColor from "../../fields3/generic/color/color"
import {AI_AGENT_ICON_CATEGORIES} from "../../gd/const/item-icon/ai-agent-categories"
import {IconType} from "../../gd-components/selector/icon-selector/@const"
import {AiAgentAccess} from "./ai-agent"
import {AIChatProvider} from "../ai/@const"

const baseConfig: FieldConfig[] = [
    {
        fieldId : 'name',
        type    : FieldType.STRING,
        label   : 'Name',
    },
    {
        fieldId : 'description',
        type    : FieldType.TEXT,
        label   : 'Description',
    },
    {
        fieldId : 'instructions',
        type    : FieldType.TEXT,
        label   : 'Instructions',
    },
    {
        fieldId             : 'provider',
        type                : FieldType.DROPDOWN,
        label               : 'Provider',
        addNoValueOption    : true,
        noValueOptionLabel  : 'Workspace default',
        showMenuMore        : false,
        options             : [
            {value: AIChatProvider.GPT_4,       label: 'GPT-4o'},
            {value: AIChatProvider.GPT_4o_MINI, label: 'GPT-4o mini'},
        ],
    },
    {
        fieldId : 'icon',
        type    : FieldType.ICON,
        label   : 'Icon',
        fieldParams : {
            iconTypes       : [IconType.ITEM_ICONS, IconType.EMOJI_ICONS, IconType.URL],
            iconCategories  : AI_AGENT_ICON_CATEGORIES,
        },
    },
    {
        fieldId             : 'color',
        type                : FieldType.COLOR,
        label               : 'Color',
        addNoValueOption    : false,
    },
    {
        fieldId         : 'access',
        type            : FieldType.RADIOGROUP,
        label           : 'Access',
        noValueOption   : false,
        showMenuMore    : false,
        options         : [
            {value: AiAgentAccess.COMPANY, label: 'Company (all members)'},
            {value: AiAgentAccess.PRIVATE, label: 'Private (only you)'},
        ],
    },
]

export default class AiAgentFields extends FieldsCollection {

    get name(): FieldString             { return this.get('name') as FieldString }
    get description(): FieldString      { return this.get('description') as FieldString }
    get instructions(): FieldString     { return this.get('instructions') as FieldString }
    get provider(): FieldString         { return this.get('provider') as FieldString }
    get icon(): FieldIcon               { return this.get('icon') as FieldIcon }
    get color(): FieldColor             { return this.get('color') as FieldColor }
    get access(): any                   { return this.get('access') }

    constructor() {
        super(baseConfig, EntityType.AI_AGENT)
    }
}
